import axios from 'axios';
import Vue from 'vue';

const AuthToken = null;

const lb = axios.create();

lb.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (AuthToken) {
      config.headers.Authorization = AuthToken;
    }
    return config;
  },
  function(error) {
    // Do something with request error
    this.$toasted.error(error, { duration: 2000, position: 'bottom-right' });
    return Promise.reject(error);
  }
);

lb.interceptors.response.use(
  res => {
    return Promise.resolve(res);
  },
  errorResponse => {
    if (errorResponse && errorResponse.response && errorResponse.response.status == 401) {
      window.localStorage.removeItem('accesstoken');
      window.localStorage.removeItem('user');
      if (window.location.pathname !== '/signup' && window.location.pathname !== '/login') {
        window.location = '/';
      }
    }
    return Promise.reject(errorResponse);
  }
);

export default lb;



// WEBPACK FOOTER //
// ./src/util/lb.js